import * as React from 'react';
import { InputWrapper, Radio } from 'vet-bones/design-system/components';

import {
  CONFIGURE_ORG_SSO_DIALOG_PROVIDER_ENTRA,
  CONFIGURE_ORG_SSO_DIALOG_PROVIDER_OKTA,
} from 'src/ui/constants/testIds';
import { SsoProviderType } from 'src/ui/graph/types';
import * as copy from 'src/ui/templates/copy';

interface ConfigureOrgSSOSelectProviderProps {
  onSelectProvider: (provider: SsoProviderType) => void;
  selectedProvider: SsoProviderType | null;
}

export const ConfigureOrgSSOSelectProvider: React.VFC<ConfigureOrgSSOSelectProviderProps> = ({
  onSelectProvider,
  selectedProvider,
}) => (
  <>
    <InputWrapper
      classNamePrefix="vb-input"
      label={copy.components.configureOrgSSO.selectProvider.label}
      labelSize="md"
      size="md"
    >
      <Radio
        checked={selectedProvider === SsoProviderType.MicrosoftEntra}
        onChange={() => onSelectProvider(SsoProviderType.MicrosoftEntra)}
        size="md"
        testId={CONFIGURE_ORG_SSO_DIALOG_PROVIDER_ENTRA}
      >
        {copy.components.configureOrgSSO.dialog.providers.microsoftEntra}
      </Radio>
      <Radio
        checked={selectedProvider === SsoProviderType.Okta}
        onChange={() => onSelectProvider(SsoProviderType.Okta)}
        size="md"
        testId={CONFIGURE_ORG_SSO_DIALOG_PROVIDER_OKTA}
      >
        {copy.components.configureOrgSSO.dialog.providers.okta}
      </Radio>
    </InputWrapper>
  </>
);
